import React from "react";

const ROWS = [0, 1, 2, 3, 4];
const WIDTHS = ["70%", "45%", "60%", "35%", "55%"];

const Bar = ({ width, tall = false }) => (
  <span className={`crm-rollo__skel${tall ? " crm-rollo__skel--tall" : ""}`} style={{ width }} aria-hidden="true" />
);

// Skeleton with the shape of the queue: two-line cells in a table card, or stacked cards on mobile.
export default function QueueSkeleton({ columns, isMobile }) {
  if (isMobile) {
    return (
      <div className="crm-rollo__cards" aria-busy="true" aria-label="Cargando gestiones">
        {ROWS.slice(0, 3).map((row) => (
          <div key={row} className="crm-rollo__card">
            <Bar width="65%" tall />
            <Bar width="40%" />
            <Bar width="85%" />
            <Bar width="55%" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="crm-rollo__table-wrap" aria-busy="true" aria-label="Cargando gestiones">
      <div className="crm-rollo__skel-table">
        {ROWS.map((row) => (
          <div key={row} className="crm-rollo__skel-row" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
            {Array.from({ length: columns }, (_, column) => (
              <div key={column} className="crm-rollo__skel-cell">
                <Bar width={WIDTHS[(row + column) % WIDTHS.length]} tall={column === 0} />
                <Bar width={WIDTHS[(row + column + 2) % WIDTHS.length]} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
